import { DeleteReq } from './deleteReq';
import { ViewDto } from './viewdto';
import { Template } from './template';
import { DynamicDocumentInfo } from './dynamic-document';

export class Tables {
  deleteReq: DeleteReq = new DeleteReq();
  id: any;
  titre: string;
  reference: string;
  title: string;
  table: string;

  dialogName: string;
  viewdto: ViewDto = new ViewDto();
  entite: any;
  public active: boolean;
  public isTable: boolean;
  value: string;
  listedechamps: any[] = ['select', 'nom'];
  activeTable: string;
  view: ViewDto = new ViewDto();
  isDynamic: boolean = false;

  type: any;
  typeName: string;
  filterTypes: any;
  msg: any;
  isMenuVisible: boolean = true;
  isExtranet: boolean = false;
  filter: any;
  condition: { [key: string]: any } = {};
  champ: string;
  lecture: boolean;
  edition: boolean;
  champType: string;
  filresappliques: {};
  ids: string[] | null;
  totalElements: number = 0;
  locales: string[];
  template: Template;
  droitTitle: any = '';
  auditLogs: any[];
  isDuplicateRecord: boolean;
  record: any;
  data: any;
  templates: { [id: string]: Template; };
  templateIdSelected: string | null;
  isRecordDuplication: boolean;
  dynamicDocumentInfo: DynamicDocumentInfo;
  nomTableField: string;
  allFields: any;
  constructor() {}
}
